import { FC } from "react";
import { Link } from "react-router-dom";

interface Props {
	name: string;
	subheading: string;
	contents: string;
	path: string;
	icon?: any;
}

const HomeLinkCard: FC<Props> = ({
	name,
	subheading,
	contents,
	icon,
	path
}) => {
	return (
		<Link to={path} className="group">
			<div className="overflow-hidden rounded-xl border border-border-light bg-white shadow-sm transition-all duration-200 group-hover:shadow-md group-hover:-translate-y-px">
				<div className="flex items-center justify-between px-6 py-5 border-b border-border">
					<h3 className="text-lg font-semibold text-foreground">{name}</h3>
					{icon && (
						<div
							aria-hidden
							className="flex h-10 w-10 shrink-0 items-center justify-center text-muted-foreground"
						>
							{icon}
						</div>
					)}
				</div>

				<div className="px-6 py-6">
					<p className="text-base font-medium text-foreground mb-2">
						{subheading}
					</p>
					<p className="text-sm leading-relaxed text-muted-foreground">
						{contents}
					</p>
				</div>
			</div>
		</Link>
	);
};

export default HomeLinkCard;
